import React, { useState } from "react";
import { Pencil, Trash2 } from "lucide-react";
import NcAssementModal from "../../../modals/admin/NcAssementModal";
import NeuroQuestionModal from "../../../modals/admin/survey/NeuroQuestionModal";

const AddSurvey = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);
    const [editingData, setEditingData] = useState(null);
    const [surveys, setSurveys] = useState([
        {
            surveyName: "Cognitive Assessment",
            audience: "John Smith",
            campus: "Main Campus",
            cls: "Grade 5",
            section: "A",
            surveyReport: "Completed"
        },
        {
            surveyName: "Memory Test",
            audience: "Sarah Johnson",
            campus: "North Campus",
            cls: "Grade 3",
            section: "B",
            surveyReport: "Pending"
        },
        {
            surveyName: "Attention Assessment",
            audience: "Tom Brown",
            campus: "South Campus",
            cls: "Grade 4",
            section: "C",
            surveyReport: "In Progress"
        }
    ]);

    const handleEdit = (index) => {
        setEditingData({ ...surveys[index], index });
        setIsModalOpen(true);
    };

    const handleDelete = (index) => {
        setSurveys(surveys.filter((_, i) => i !== index));
    };

    const handleAddQuestion = (survey) => {
        setIsQuestionModalOpen(true);
    };

    const handleAddNew = () => {
        setEditingData(null);
        setIsModalOpen(true);
    };

    const handleSave = (data) => {
        if (editingData) {
            const updated = surveys.map((item, index) =>
                index === editingData.index ? data : item
            );
            setSurveys(updated);
        } else {
            setSurveys([...surveys, data]);
        }
        setIsModalOpen(false);
        setEditingData(null);
    };

    return (
        <>
            <div className="flex w-full items-center justify-between mt-4 space-x-2">
                <input
                    type="text"
                    placeholder="Search..."
                    className="border border-gray-300 rounded p-2 w-3/4"
                />
                <button
                    onClick={handleAddNew}
                    className="px-4 py-2 bg-[#241763] w-1/4 text-white rounded"
                >
                    <span className="text-lg"></span> Add NC Assesment
                </button>
            </div>

            <div className="overflow-x-auto mt-6">
                <table className="table-auto w-full mt-6">
                    <thead className="py-4 border-b font-bold">
                        <tr className="bg-gray-100 border-b">
                            <th className="p-3">Survey Name</th>
                            <th className="p-3">Audience</th>
                            <th className="p-3">Campus</th>
                            <th className="p-3">Class</th>
                            <th className="p-3">Section</th>
                            <th className="p-3">Survey Report</th>
                            <th className="p-3"> Details </th>
                            <th className="p-3">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="text-sm">
                        {surveys.map((survey, index) => (
                            <React.Fragment key={index}>
                                <tr className="hover:bg-gray-200">
                                    <td>{survey.surveyName}</td>
                                    <td>{survey.audience}</td>
                                    <td>{survey.campus}</td>
                                    <td>{survey.cls}</td>
                                    <td>{survey.section}</td>
                                    <td>{survey.surveyReport}</td>
                                    <td>
                                        <button
                                            className="bg-[#241763] text-white px-3 py-1 rounded hover:bg-[#241763]/80"
                                            onClick={() => handleAddQuestion(survey)}
                                        >
                                            Add Question
                                        </button>
                                    </td>
                                    <td className="space-x-2 flex items-center py-2">
                                        <button
                                            className="bg-[#B6A5C9]/50 text-white p-2 rounded hover:bg-[#241763]/60 group"
                                            onClick={() => handleEdit(index)}
                                        >
                                            <Pencil className="text-[#241763] w-4 h-4 group-hover:text-white" />
                                        </button>
                                        <button
                                            className="bg-[#B6A5C9]/50 text-white p-2 rounded hover:bg-[#241763]/60 group"
                                            onClick={() => handleDelete(index)}
                                        >
                                            <Trash2 className="text-[#241763] w-4 h-4 group-hover:text-white" />
                                        </button>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>

            {isModalOpen && (
                <NcAssementModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    onSave={handleSave}
                    editingData={editingData}
                />
            )}

            {isQuestionModalOpen && (
                <NeuroQuestionModal
                    isOpen={isQuestionModalOpen}
                    onClose={() => setIsQuestionModalOpen(false)}
                />
            )}
        </>
    );
};

export default AddSurvey;